import { render, staticRenderFns } from "./pbrConfirmForm.vue?vue&type=template&id=14af9c16&"
import script from "./pbrConfirmForm.vue?vue&type=script&lang=js&"
export * from "./pbrConfirmForm.vue?vue&type=script&lang=js&"
import style0 from "./pbrConfirmForm.vue?vue&type=style&index=0&id=14af9c16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports